import ControlRoomLayout from '../../components/layout/ControlRoomLayout';
import DeptMessages from '../../components/DeptMessages';

export default function CrMessagesPage() {
  return (
    <ControlRoomLayout>
      <DeptMessages dept="Control Room" color="orange" testPrefix="cr" />
    </ControlRoomLayout>
  );
}
